export default {"src":"/_next/static/media/home-screen.793e0992.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};